module.exports = __webpack_public_path__ + "static/img/14000098.1d853259.png";